import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { launchQuizRequested } from 'features/quizzes/actions';

export function* launchQuizSaga(action: ReturnType<typeof launchQuizRequested>) {
  yield call(SignalingSocket.send, { event: 'launchQuiz', data: { id: action.payload } });
}
